import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled from 'styled-components';

interface WBSNavButtonProps {
  wide?: boolean;
  icon?: IconDefinition;
  children?: React.ReactNode;
}

export const WBSNavButton = ({
  icon,
  children,
  ...props
}: WBSNavButtonProps & React.ButtonHTMLAttributes<HTMLButtonElement>) => {
  return (
    <StyledNavButton {...props} $hasIcon={!!icon}>
      {icon && <NavButtonIcon icon={icon} />}
      {children}
    </StyledNavButton>
  );
};

const StyledNavButton = styled.button<{
  wide?: boolean;
  $hasIcon?: boolean;
}>`
  align-items: center;
  background-color: var(--grey-200);
  border: none;
  border-radius: 4px;
  box-shadow: var(--shadow-sm);
  color: var(--grey-900);
  cursor: pointer;
  display: inline-flex;
  font-family: var(--raleway);
  font-size: ${(props) => (props.wide ? '11px' : '12px')};
  font-weight: ${(props) => (props.wide ? '400' : '500')};
  gap: 8px;
  justify-content: center;
  letter-spacing: 0.6px;
  padding: ${(props) =>
    props.wide ? (props.$hasIcon ? '6px 17px' : '6px 25px') : '5px 10px'};
  transition: all 0.2s ease-in-out;

  &:hover:not(:disabled) {
    background-color: var(--grey-300);
    box-shadow: var(--shadow-sm);
    color: var(--grey-900);
  }

  &:disabled {
    background-color: var(--grey-300);
    box-shadow: var(--shadow-sm);
    color: var(--grey-500);
    cursor: not-allowed;
    opacity: 1;
  }
`;

const NavButtonIcon = styled(FontAwesomeIcon)`
  color: inherit;
  font-size: 14px;
  transition: color 0.2s ease-in-out;

  ${StyledNavButton}:hover:not(:disabled) & {
    color: inherit;
  }

  ${StyledNavButton}:disabled & {
    color: var(--grey-500);
  }
`;
